export enum FormSettingsTypeEnum {
  Unknown = 0,
  Text = 1,
  Multiline = 2,
  Readonly = 3,
  Dropdown = 4,
  List = 5,
  CheckboxRadio = 6,
  Checkbox = 7,
  Html = 8,
  Image = 9,
  Country = 10,
  Phone = 11,
  Community = 12,
  County = 13,
  PostNr = 14,
  Interested = 15,
  Password = 16,
  CheckboxLabelAfter = 17,
  Hidden = 18,
  Email = 19,
  Birthdate = 20,
  Label = 21,
  Header = 33,
  EmailCompare = 37,
}
